import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import showToast from '../../utils/toast';
import AuthLayout from '../../components/auth/AuthLayout';

const DEMO_PASSWORD = '1313';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const mobile = location.state?.mobile || localStorage.getItem('resetMobile') || '';

  useEffect(() => {
    const storedOtp = localStorage.getItem('resetOtp');
    if (!mobile || !storedOtp) {
      navigate('/forgot-password', { replace: true });
    }
  }, [mobile, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setError('Please enter and confirm your new password.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (password !== DEMO_PASSWORD) {
      setError(`For this demo, the password must remain ${DEMO_PASSWORD}.`);
      return;
    }

    setLoading(true);
    setError('');

    showToast.success('Password updated successfully.');

    localStorage.removeItem('resetMobile');
    localStorage.removeItem('resetOtp');

    navigate('/login');
    setLoading(false);
  };

  const handleBack = () => {
    navigate('/verify-otp', { state: { mobile } });
  };

  return (
    <AuthLayout
      title="Reset Password"
      subtitle={`Set a new password for ${mobile ? `+91 ${mobile}` : 'your account'}.`}
      onBack={handleBack}
    >
      {error && (
        <div className="toast-error">
          <div className="toast-content">
            <div className="toast-icon">⚠️</div>
            <div className="toast-text">{error}</div>
            <button className="toast-close" onClick={() => setError('')}>
              ×
            </button>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">New Password</label>
          <input
            type="password"
            className="form-input"
            placeholder="Enter new password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (error) {
                setError('');
              }
            }}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Confirm Password</label>
          <input
            type="password"
            className="form-input"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              if (error) {
                setError('');
              }
            }}
            required
          />
        </div>

        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Updating password...' : 'Update Password'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default ResetPassword;


